import { NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, takeUntil, tap } from 'rxjs/operators';
import { DownloadItem } from './download-item';
import { DownloadEventTypes } from './download-progress-event';
import { DownloadApiService } from './download-api.service';
import { Store } from '@ngxs/store';
import { DriveState } from '../../app/drive/state/drive-state';
import { Settings } from '../core/config/settings.service';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "../core/config/settings.service";
import * as i3 from "@angular/common/http";
var DownloadItemService = /** @class */ (function () {
    function DownloadItemService(zone, store, settings, http) {
        this.zone = zone;
        this.store = store;
        this.settings = settings;
        this.http = http;
        this.download$ = new BehaviorSubject(null);
        this.totalProgress$ = new BehaviorSubject(0);
        this.progress$ = new BehaviorSubject(null);
        this.api = null;
    }
    DownloadItemService.prototype.get = function () {
        return this.download$.asObservable();
    };
    DownloadItemService.prototype.updateTotalProgress = function () {
        var progress = this.download$.value.meta$.value.progress || 0;
        this.totalProgress$.next(progress);
    };
    DownloadItemService.prototype.totalProgress = function () {
        return this.totalProgress$.asObservable();
    };
    DownloadItemService.prototype.progress = function () {
        return this.progress$.asObservable();
    };
    DownloadItemService.prototype.start = function (fileEntry, link, password) {
        var _this = this;
        var download = new DownloadItem(fileEntry);
        this.download$.next(download);
        this.api = new DownloadApiService(this.http);
        var request = this.api.start(this.getChunkDownloadUrl(link, password), download.fileEntry).pipe(takeUntil(download.canceled$), tap(function (response) { return _this.handleDownloadEvent(response, download); }, function (response) { return _this.handleDownloadFailure(response, download); }));
        return request
            .pipe(filter(function (e) { return e.name === DownloadEventTypes.COMPLETED; }), map(function (e) { return e.fileEntry; }));
    };
    DownloadItemService.prototype.updateProgress = function (id, e) {
        var queueItem = this.download$.value;
        if (!queueItem)
            return;
        queueItem.update({
            eta: e.eta,
            speed: e.speed,
            progress: e.progress,
            totalBytes: e.totalBytes,
            completedBytes: e.completedBytes,
        });
        this.updateTotalProgress();
    };
    DownloadItemService.prototype.completeDownload = function (id, fileEntry, totalCachedCf, totalCachedEdge) {
        var queueItem = this.download$.value;
        if (!queueItem)
            return;
        queueItem.fileEntry = fileEntry;
        queueItem.totalCachedCf = totalCachedCf;
        queueItem.totalCachedEdge = totalCachedEdge;
        queueItem.complete();
    };
    DownloadItemService.prototype.errorDownload = function (id, message) {
        if (message === void 0) { message = ''; }
        this.download$.value.addError(message);
    };
    DownloadItemService.prototype.abortDownload = function () {
        if (this.api) {
            if (this.api.getFileStream())
                this.api.getFileStream().abort();
            if (this.api.getFileWriter())
                this.api.getFileWriter().abort();
        }
    };
    DownloadItemService.prototype.reset = function () {
        this.download$.next(null);
    };
    DownloadItemService.prototype.handleDownloadEvent = function (event, download) {
        var _this = this;
        this.progress$.next(event);
        if (event.name === DownloadEventTypes.PROGRESS) {
            this.zone.run(function () {
                _this.updateProgress(download.id, event);
            });
        }
        else if (event.name === DownloadEventTypes.COMPLETED) {
            this.zone.run(function () {
                _this.completeDownload(download.id, event.fileEntry, event.totalCachedCf, event.totalCachedEdge);
            });
        }
    };
    DownloadItemService.prototype.handleDownloadFailure = function (response, download) {
        var msg = response.messages ? response.messages.file : '';
        this.errorDownload(download.id, msg);
    };
    DownloadItemService.prototype.getChunkDownloadUrl = function (link, password) {
        var fileEntry = link.entry;
        var hashes = this.getEntryHashes(fileEntry);
        var base = this.settings.getBaseUrl() + "secure/uploads/downloadChunk?hashes=" + hashes;
        if (link)
            base += "&shareable_link=" + link.id;
        if (password)
            base += "&password=" + password;
        return base;
    };
    /**
     * Get hashes string for specified entries or for currently selected entries.
     */
    DownloadItemService.prototype.getEntryHashes = function (entry) {
        if (!entry) {
            entry = this.store.selectSnapshot(DriveState.selectedEntries[0]);
        }
        return entry.hash;
    };
    DownloadItemService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DownloadItemService_Factory() { return new DownloadItemService(i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.Settings), i0.ɵɵinject(i3.HttpClient)); }, token: DownloadItemService, providedIn: "root" });
    return DownloadItemService;
}());
export { DownloadItemService };
